import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Auto-refresh: if any request fails with 401 and we haven't already retried,
// try to swap our refresh_token cookie for a new access token, then replay the request.
let refreshPromise = null;
api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status !== 401 || original._retried) throw error;
    // Never try to refresh on auth endpoints themselves.
    const url = original.url || "";
    if (url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/logout")) throw error;

    original._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      return api(original);
    } catch (_) {
      throw error;
    }
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
